import { Outlet, Navigate, useLocation } from 'react-router-dom'
import { AdminSidebar } from './AdminSidebar'
import { AdminHeader } from './AdminHeader'
import { SalesAgentChat } from './SalesAgentChat'
import { useAuth } from '@/hooks/useAuth'
import { PageHeaderProvider } from '@/contexts/PageHeaderContext'

// Sales-related paths where the AI chat should be visible
const SALES_PATHS = ['/admin/leads', '/admin/shortlist', '/admin/quotes']

export function AdminLayout() {
  const { isAuthenticated, isLoading } = useAuth()
  const location = useLocation()

  const isSalesPage = SALES_PATHS.some(path => location.pathname.startsWith(path))

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-secondary-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600" />
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />
  }

  return (
    <PageHeaderProvider>
      <div className="min-h-screen bg-secondary-50">
        <AdminSidebar />
        <div className="lg:pl-64">
          <AdminHeader />
          <main>
            <Outlet />
          </main>
        </div>
        {isSalesPage && <SalesAgentChat />}
      </div>
    </PageHeaderProvider>
  )
}
